import React from 'react';

/**
 * ConsultantDashboardSessionTabs
 *
 * Props:
 * - activeTab: string
 * - onChange: (tabId: string) => void
 * - tabCounts: {
 *     active,
 *     completed,
 *     assigned,
 *     engagements,
 *     scheduled
 *   }
 */
const ConsultantDashboardSessionTabs = ({ activeTab, onChange, tabCounts }) => {
  const tabs = [
    { id: 'active', label: 'Active Sessions', count: tabCounts.active },
    { id: 'completed', label: 'Completed Sessions', count: tabCounts.completed },
    { id: 'assigned', label: 'Assigned Users', count: tabCounts.assigned },
    { id: 'engagements', label: 'Engagements', count: tabCounts.engagements },
    { id: 'scheduled', label: 'Scheduled', count: tabCounts.scheduled }
  ];

  return (
    <div className="px-6 py-2 border-b border-gray-200 dark:border-gray-700 overflow-x-auto">
      <nav className="flex space-x-6 md:space-x-8 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
              activeTab === tab.id
                ? 'border-emerald-500 text-emerald-600 dark:text-emerald-400'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {tab.label} {tab.count > 0 && <span className="ml-1 text-xs">({tab.count})</span>}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ConsultantDashboardSessionTabs;


